import { render, staticRenderFns } from "./mrptranspurorder.vue?vue&type=template&id=1b3e2868&scoped=true&"
import script from "./mrptranspurorder.vue?vue&type=script&lang=js&"
export * from "./mrptranspurorder.vue?vue&type=script&lang=js&"
import style0 from "./mrptranspurorder.vue?vue&type=style&index=0&id=1b3e2868&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e2868",
  null
  
)

export default component.exports